var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.81922 15.0683L4.66797 10.917L14.815 0.769531L18.9662 4.92078L8.81922 15.0683ZM7.03937 10.917L8.81922 12.6969L16.5953 4.92078L14.8155 3.14094L7.03937 10.917Z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.8344 5.05693L17.6489 3.871C18.1397 3.38021 18.1397 2.58193 17.6489 2.09115C17.1581 1.60037 16.3598 1.60084 15.8691 2.09115L14.6836 0.905215C15.8283 -0.239473 17.6902 -0.239004 18.8348 0.905215C19.9791 2.0499 19.9791 3.91225 18.8344 5.05693Z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.04119 15.8572C4.73697 15.8572 4.44166 15.7372 4.22229 15.5178C3.95182 15.2473 3.83229 14.8611 3.9026 14.4852L4.38775 11.8944C4.39385 11.862 4.39713 11.8377 4.39807 11.8212C4.42385 11.3881 4.60666 10.9817 4.91275 10.6756L5.85447 9.73438L10.0057 13.8856L9.064 14.8273C8.77291 15.1184 8.3876 15.2994 7.97791 15.3373C7.8865 15.3458 7.7876 15.3631 7.71166 15.3772L5.25494 15.837C5.18369 15.8506 5.11197 15.8572 5.04119 15.8572ZM6.02275 12.2741L5.69041 14.0502L7.40322 13.7295C7.42338 13.7258 7.44447 13.722 7.4665 13.7178L6.02275 12.2741Z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.5039 18.9497H3.60203C1.78609 18.9497 0.308594 17.4722 0.308594 15.6562V5.75437C0.308594 3.93844 1.78609 2.46094 3.60203 2.46094H9.65781V3.83297H3.60203C2.54266 3.83297 1.68062 4.695 1.68062 5.75437V15.6562C1.68062 16.7156 2.54266 17.5777 3.60203 17.5777H13.5039C14.5633 17.5777 15.4253 16.7156 15.4253 15.6562V10.0078H16.7973V15.6562C16.7973 17.4722 15.3198 18.9497 13.5039 18.9497Z",
    fill: "#4D4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.e1b5f38729013a3564924698b0b1bc29.svg";
export { ForwardRef as ReactComponent };